/* THIS IS AN AUTOGENERATED FILE. */

// You can edit this file and additionally inject custom components into MDX.
// However, do not forget to import the './addon-components.js' file!

import addonComponents from './addon-components';

export default { ...addonComponents };
